/**
 * 制作進捗 (workflow stage) のラベル解決。
 *
 * 組織別ステージ行 (organization_material_workflow_stages) を enabled=false にしても
 * 素材・シナリオ側の参照 (workflow_stage_id) は残る一方、/materials/workflow-stages は
 * 有効なステージしか返さない。そのままでは無効化済みの値が「未設定」と見分けられず、
 * 「未設定」フィルタ (IS NULL) には一致しないので表示と検索結果が食い違う。
 * ここで「未設定 / ステージ / 無効なステージ」の3状態に分けて返す。
 * docs/features/workflow-stage-take8-and-scenario-book-plan.md §3.4.5
 */
import type { MaterialWorkflowStage } from './api';

export type ResolvedWorkflowStage =
  | { kind: 'none'; label: '未設定' }
  | { kind: 'stage'; label: string; colorHex: string | null; stage: MaterialWorkflowStage }
  | { kind: 'orphan'; label: '無効なステージ' };

export const ORPHAN_WORKFLOW_STAGE_HINT =
  'このステージは組織の設定で無効化されています。編集で別のステージか未設定を選べます';

export function resolveWorkflowStageLabel(
  stageId: string | null | undefined,
  stages: ReadonlyArray<MaterialWorkflowStage>,
): ResolvedWorkflowStage {
  if (!stageId) return { kind: 'none', label: '未設定' };
  const stage = stages.find((s) => s.id === stageId);
  if (!stage) return { kind: 'orphan', label: '無効なステージ' };
  return { kind: 'stage', label: stage.label, colorHex: stage.color_hex ?? null, stage };
}
